"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("@ledgerhq/errors");
const bignumber_js_1 = require("bignumber.js");
const address_1 = require("@celo/utils/lib/address");
const errors_2 = require("./errors");
const logic_1 = require("./logic");
const sdk_1 = require("./api/sdk");
const kit = (0, sdk_1.celoKit)();
// Arbitrary buffer for paying fees of next transactions. 0.05 Celo for ~100 transactions
const FEES_SAFETY_BUFFER = new bignumber_js_1.BigNumber(5000000000000000);
const getTransactionStatus = (account, transaction) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    const errors = {};
    const warnings = {};
    const useAllAmount = !!transaction.useAllAmount;
    if (account.freshAddress === transaction.recipient) {
        errors.recipient = new errors_1.InvalidAddressBecauseDestinationIsAlsoSource();
    }
    if (!transaction.fees || !transaction.fees.gt(0)) {
        errors.fees = new errors_1.FeeNotLoaded();
    }
    const pendingOperationAmounts = (0, logic_1.getPendingStakingOperationAmounts)(account);
    const lockedGold = yield kit.contracts.getLockedGold();
    const nonvotingLockedGoldBalance = yield lockedGold.getAccountNonvotingLockedGold(account.freshAddress);
    // Deduct pending vote operations from the non-voting locked balance
    const totalNonVotingLockedBalance = nonvotingLockedGoldBalance.minus(pendingOperationAmounts.vote);
    // Deduct pending lock operations from the spendable balance
    const totalSpendableBalance = account.spendableBalance.minus(pendingOperationAmounts.lock);
    const estimatedFees = transaction.fees || new bignumber_js_1.BigNumber(0);
    let amount = new bignumber_js_1.BigNumber(0);
    if (useAllAmount && (transaction.mode === "unlock" || transaction.mode === "vote")) {
        amount = totalNonVotingLockedBalance !== null && totalNonVotingLockedBalance !== void 0 ? totalNonVotingLockedBalance : new bignumber_js_1.BigNumber(0);
    }
    else if (useAllAmount && transaction.mode === "revoke") {
        const revoke = (0, logic_1.getVote)(account, transaction.recipient, transaction.index);
        if (revoke === null || revoke === void 0 ? void 0 : revoke.amount)
            amount = revoke.amount;
    }
    else if (useAllAmount) {
        amount = totalSpendableBalance.minus(estimatedFees);
    }
    else {
        amount = new bignumber_js_1.BigNumber(transaction.amount);
    }
    if (amount.lt(0))
        amount = new bignumber_js_1.BigNumber(0);
    if ((((_a = account.celoResources) === null || _a === void 0 ? void 0 : _a.lockedBalance.gt(0)) ||
        !!((_c = (_b = account.celoResources) === null || _b === void 0 ? void 0 : _b.pendingWithdrawals) === null || _c === void 0 ? void 0 : _c.length)) &&
        (transaction.useAllAmount || totalSpendableBalance.minus(amount).lt(FEES_SAFETY_BUFFER)) &&
        ["send", "lock"].includes(transaction.mode)) {
        warnings.amount = new errors_2.CeloAllFundsWarning();
    }
    if (!["register", "withdraw", "activate"].includes(transaction.mode)) {
        if (!errors.amount && amount.lte(0) && !useAllAmount) {
            errors.amount = new errors_1.AmountRequired();
        }
    }
    const totalSpent = amount.plus(estimatedFees);
    if (transaction.mode === "unlock" || transaction.mode === "vote") {
        if (!errors.amount && totalNonVotingLockedBalance && amount.gt(totalNonVotingLockedBalance)) {
            errors.amount = new errors_1.NotEnoughBalance();
        }
    }
    else if (transaction.mode === "revoke") {
        const revoke = (0, logic_1.getVote)(account, transaction.recipient, transaction.index);
        if (!errors.amount && (revoke === null || revoke === void 0 ? void 0 : revoke.amount) && amount.gt(revoke.amount))
            errors.amount = new errors_1.NotEnoughBalance();
    }
    else {
        if (!errors.amount && totalSpent.gt(totalSpendableBalance)) {
            errors.amount = new errors_1.NotEnoughBalance();
        }
    }
    if (!errors.amount && totalSpendableBalance.lt(estimatedFees)) {
        errors.amount = new errors_1.NotEnoughBalance();
    }
    if (transaction.mode === "send") {
        if (!transaction.recipient) {
            errors.recipient = new errors_1.RecipientRequired();
        }
        else if (!(0, address_1.isValidAddress)(transaction.recipient)) {
            errors.recipient = new errors_1.InvalidAddress("", {
                currencyName: account.currency.name,
            });
        }
    }
    return Promise.resolve({
        errors,
        warnings,
        estimatedFees,
        amount,
        totalSpent,
    });
});
exports.default = getTransactionStatus;
//# sourceMappingURL=js-getTransactionStatus.js.map